var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckboxChecked(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 19,
    height: 19,
    rx: 9.5,
    stroke: "#0DD1C5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.274 13.82a.684.684 0 01-.448-.18L5.69 10.414a.703.703 0 010-.985.703.703 0 01.986 0l2.598 2.688 5.466-5.735a.703.703 0 01.986 0 .703.703 0 010 .986L9.812 13.64c-.18.09-.359.18-.538.18z",
    fill: "#0DD1C5"
  })));
}
export default SvgCheckboxChecked;